"use client";
import Grid from "@/shared/components/common/Grid";
import { useDeviceType } from "@/shared/context/DeviceContext";
import useSticky from "@/shared/hooks/useSticky";
import { cn } from "@/shared/libs/commonUtils";
import type { ReactNode } from "react";

type ClassName = {
  parent?: string;
  mainContentStyle?: string;
  sideContentStyle?: string;
};

interface DualLayoutProps {
  sidebarPosition?: "right" | "left";
  className?: string | ClassName;
  mainContent: ReactNode;
  sideContent: ReactNode;
}

export default function DualLayout({
  sidebarPosition = "right",
  className,
  mainContent,
  sideContent,
}: DualLayoutProps) {
  const { parent, mainContentStyle, sideContentStyle } =
    (className as ClassName) ?? {
      parent: "",
      mainContent: "",
      sideContent: "",
    };

  return (
    <Grid
      className={cn("grid-cols-12 px-3 xl:px-0 md:pb-8 sm:gap-4 py-5", parent)}
    >
      {sidebarPosition === "right" ? (
        <>
          <SidebarContent style={sideContentStyle ?? ""}>
            {sideContent}
          </SidebarContent>

          <MainContent style={mainContentStyle ?? ""}>
            {mainContent}
          </MainContent>
        </>
      ) : (
        <>
          <MainContent style={mainContentStyle ?? ""}>
            {mainContent}
          </MainContent>

          <SidebarContent style={sideContentStyle ?? ""}>
            {sideContent}
          </SidebarContent>
        </>
      )}
    </Grid>
  );
}

const MainContent = ({
  children,
  style,
}: {
  children: ReactNode;
  style: string;
}) => (
  <Grid.GridCol
    className={cn("col-span-9 max-lg:col-span-12 flex flex-col gap-y-6", style)}
  >
    {children}
  </Grid.GridCol>
);
const SidebarContent = ({
  children,
  style,
}: {
  children: ReactNode;
  style: string;
}) => {
  const isSticky = useSticky(100);
  const device = useDeviceType();
  // TODO : find a better way for style sidebar like that
  return (
    <Grid.GridCol
      className={cn(
        "col-span-3 flex flex-col gap-y-3 max-lg:col-span-12",
        `${
          isSticky &&
          device === "mobile" &&
          "sticky top-14 w-full right-0 pt-2 bg-card z-50 animate-fade-in border-b border-grayColor scale-x-105 px-3"
        }`,
        style,
      )}
    >
      {children}
    </Grid.GridCol>
  );
};
